import { type ComponentProps } from 'react'
import { twMerge } from 'tailwind-merge'

interface CellFooterProps extends ComponentProps<'div'> {}

function CellFooter({ className, children, ...props }: CellFooterProps) {
  return (
    <div
      data-slot="cell-footer"
      className={twMerge('text-foreground-secondary flex basis-full items-center justify-between text-sm', className)}
      {...props}
    >
      {children}
    </div>
  )
}

export { CellFooter }
